import { Checkbox, TextHighlight, TextSize } from '@focaldata/cin-ui-components'
import React, { memo } from 'react'
import { SettingValue } from '../../../data/model/questionnaire'
import { getSettingValue } from '../../../utils/HelperFunctions'
import { WithEntry, propsAreEqual } from '../../../utils/questionnaireUtils'
import { Option } from './DefaultOptions'
import useStyles from './QuestionCardDefaultOptions.styles'

interface Props extends WithEntry {
  options?: ({
    checked?: boolean
    onChange?: (
      settingValue: SettingValue.Enabled | SettingValue.Disabled
    ) => void
  } & Option)[]
}

const QuestionCardDefaultOptions: React.FC<Props> = (props: Props) => {
  const { options } = props

  const { classes, cx: classNames } = useStyles()

  const textSize = TextSize.ms

  return (
    <div className={classNames('fd-grid fd-container', classes.root)}>
      {options?.map((option) => (
        <div key={option.code} className="fd-grid fd-item fd-xs-auto">
          <Checkbox
            checked={option.checked}
            ariaLabel={option.label}
            label={option.label}
            textSize={textSize}
            textHighlight={TextHighlight.Background}
            onChange={(event) => {
              const settingValue = getSettingValue(event.target.checked)
              if (option.onChange) {
                option.onChange(settingValue)
              }
            }}
          />
        </div>
      ))}
    </div>
  )
}

export default memo(QuestionCardDefaultOptions, propsAreEqual)
